import { useState, useEffect } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="トップへ戻る"
      className={`
        fixed bottom-20 right-8 z-50
        w-12 h-12 flex items-center justify-center
        bg-stone-800 text-white
        rounded-full shadow-md
        transition-all duration-300 cursor-pointer
        hover:bg-stone-600 hover:scale-110
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}
      `}
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}
